<template src="./DeliveryDataCreateComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {ref, computed, reactive, onMounted, watch} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import {useDeliveryStore} from "@/stores/delivery.js";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import {usePartnerStore} from "@/stores/partner.js";
import {AppConstant} from "@/supports/app.constant";
import {ErrorText} from "@/supports/error-message.constant";
import InputNumberComponent from "@/components/inputs/input-number/InputNumberComponent.vue";
import {useRoute, useRouter} from "vue-router";
import {useProductStore} from "@/stores/product.js";
import {useStore} from "@/stores/store.js";
export default {
  name: 'DeliveryDataCreateComponent',
  components: {
    InputNumberComponent,
    LoadingComponent,
    ModalDeliveryProductListComponent,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome
  },
  setup() {
    const errors = ref(true)
    const dataDelivery = ref({
      delivery_name: {
        id: 'delivery_name',
        label: 'Tên dữ liệu giao hàng',
        placeholder: 'Tên dữ liệu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: true
      },
      store_id: {
        id: 'store_id',
        label: 'Cửa hàng',
        placeholder: 'Cửa hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: []
      },
      partner_id: {
        id: 'partner_id',
        label: 'Đối tác giao hàng',
        placeholder: 'Đối tác giao hàng',
        value: '',
        error: '',
        isError: false,
        required: false,
        options: []
      },
      delivery_description: {
        id: 'delivery_description',
        label: 'Mô tả dữ liệu giao hàng',
        placeholder: 'Mô tả dữ liệu giao hàng',
        value: '',
        error: '',
        isError: false,
        required: false
      },
    })
    const dataHeaderTable = ref({
      sortRecord: {
        label: '#',
        order: 1,
        width: '2%',
      },
      product_name: {
        label: 'Tên sản phẩm',
        order: 2,
        width: '15%',
      },
      product_code: {
        label: 'Mã sản phẩm',
        order: 3,
        width: '10%',
      },
      product_price: {
        label: 'Giá sản phẩm',
        order: 4,
        width: '10%',
      },
      product_selling_price: {
        label: 'Giá bán sản phẩm',
        order: 5,
        width: '10%',
      },
      product_tax: {
        label: 'Thuế (%)',
        order: 6,
        width: '10%',
      },
      product_unit: {
        label: 'Đơn vị',
        order: 7,
        width: '10%',
      },
    })
    const labelSelectProduct = ref('Chọn sản phẩm')
    const listProductsSelected = ref([])
    const eventClickShowModal = ref(false)
    const isLoading = ref(false)
    const totalPrice = ref(0)
    const partnerStore = usePartnerStore()
    const deliveryStore = useDeliveryStore()
    const productStore = useProductStore()
    const accountStore = useAccountStore()
    const storeCompStore = useStore()
    const mode = ref('create')
    const labelButtonSetting = ref('Tạo dữ liệu kho hàng')
    const delivery_id = ref(null)
    const router = useRouter()
    const route = useRoute()
    const stateModal = reactive({
      modalDeliveryProductList: null,
    })

    // set up modal and call api get list partner
    onMounted(() => {
      mode.value = route.params.mode;
      if(mode.value === 'detail') {
        labelButtonSetting.value = 'Cập nhập dữ liệu kho hàng';
        delivery_id.value =  route.params.id;
        if(productStore.products.length === 0) {
          getListProductsByIds()
        }
        getDeliveryDetail()
      }
      if(storeCompStore.stores.length === 0) {
        getListStores()
      }else {
        storeCompStore.stores.forEach((item) => {
          dataDelivery.value.store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
      stateModal.modalDeliveryProductList = new bootstrap.Modal('#modaldeliveryProduct', {})
      getListPartner();
    })

    async function getListStores() {
      const params = {
        id: accountStore.account.company.id,
        type: 1
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/stores/list-stores';
      await storeCompStore.getListStores(url, params);
    }

    watch(() => storeCompStore.stores, (newListStores) => {
      if(newListStores.length) {
        newListStores.forEach((item) => {
          dataDelivery.value.store_id.options.push({
            name: item.name,
            value: item.id
          })
        })
      }
    });

    watch(() => deliveryStore.masterDeliveryDetail, (masterDeliveryDetail) => {
      if(masterDeliveryDetail) {
        dataDelivery.value.delivery_name.value = masterDeliveryDetail.exchange_delivery_name;
        dataDelivery.value.delivery_description.value = masterDeliveryDetail.exchange_delivery_name;
        dataDelivery.value.partner_id.value = masterDeliveryDetail.partner_id;
        listProductsSelected.value = JSON.parse(JSON.stringify(masterDeliveryDetail.delivery_detail_deep));

        // if(productStore.products.length > 0) {
        //   productStore.products.forEach((product) => {
        //     const productMatch = listDeliveryDetail.find((deliveryDetail) => deliveryDetail.id === product.id)
        //     if(productMatch) {
        //       listProductsSelected.value.push(product)
        //     }
        //   })
        // }
      }
    })

    async function getListProductsByIds() {
      const params = {
        company_id: accountStore.account.company.id,
        product_ids: listProductIds.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/product/product-list-id';
      await productStore.getListProductsByIds(url, params);
    }

    // listen change list partner
    const listPartners = computed(() => {
      return partnerStore.partners;
    });
    // call api list partner
    async function getListPartner() {
      const params = {
        id: accountStore.account.company.id,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/partner/partner-list';
      await partnerStore.getListPartners(url, params);
      partnerStore.partners.forEach((partner) => {
        dataDelivery.value.partner_id.options.push({
          name: partner.partner_name,
          value: partner.partner_company_id
        })
      })
    }
    // create delivery
    async function createDelivery() {
      validateForm(dataDelivery.value.delivery_name.value, 'exchange_delivery_name')
      const deliveryDetail = [];
      listProductsSelected.value.forEach((product) => {
        deliveryDetail.push(product.id)
      })
      if(checkSubmitActive.value) {
        const params = {
          m_company_id: accountStore.account.company.id,
          m_user_created_id: CommonService.getUserId(),
          store_id: dataDelivery.value.store_id.value,
          exchange_delivery_name: dataDelivery.value.delivery_name.value,
          partner_id: CommonService.isEmpty(dataDelivery.value.partner_id.value) ? 0 : dataDelivery.value.partner_id.value,
          exchange_delivery_description: dataDelivery.value.delivery_description.value,
          delivery_detail: deliveryDetail,
        }
        let url = AppConstant.URL_API_LOCAL + 'api/v1/m-deliveries/create-master-deliveries';
        if(mode.value === 'detail') {
          params.id = delivery_id.value;
          url = AppConstant.URL_API_LOCAL + 'api/v1/m-deliveries/update-master-deliveries';
        }
        const delivery = await deliveryStore.createDeliveries(url, params);
        await CommonService.showAlertPopup({
          title: delivery?.message,
          icon: "success",
          showConfirmButton: false,
          timer: 1000,
          width: '800px'
        });
      }
      resetForm()
    }

    function getDeliveryDetail() {
      const params = {
        company_id: accountStore.account.company.id,
        delivery_id: delivery_id.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/m-deliveries/detail';
      deliveryStore.getMasterDeliveryDetail(url, params);
    }
    function onChange(value, name) {
      dataDelivery.value[name].value = value
    }
    function validateForm(value, name) {
      if(name === 'exchange_delivery_name') {
        dataDelivery.value.delivery_name.isError = false;
        dataDelivery.value.delivery_name.error = ''
        errors.value = false
        if(!value) {
          dataDelivery.value.delivery_name.isError = true;
          dataDelivery.value.delivery_name.error = ErrorText.REQUIRED(dataDelivery.value.delivery_name.label);
          errors.value = true
        }
      }
    }

    function showModalProductList () {
      eventClickShowModal.value = true
      isLoading.value = true
    }

    const checkSubmitActive = computed(() => {
      return !errors.value;
    })

    function showModalProduct(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModal.value = false
          isLoading.value = false
          stateModal.modalDeliveryProductList.show()
        }, 1000);
        return;
      }
      stateModal.modalDeliveryProductList.hide()
    }

    function eventSearchProduct(isSearch) {
      if(!eventClickShowModal.value) {
        isLoading.value = isSearch
      }
    }

    function eventGetListProductsSelected(listProductsSelectedCurrent) {
      listProductsSelected.value = listProductsSelectedCurrent
      listProductsSelected.value.forEach((product) => {
        product.tax_rate = product.product_tax;
      })
    }

    function resetForm() {
      dataDelivery.value.delivery_name.value = ''
      dataDelivery.value.delivery_description.value = ''
      dataDelivery.value.partner_id.value = ''
      dataDelivery.value.store_id.value = ''
      listProductsSelected.value = []
    }

    return {
      listPartners,
      totalPrice,
      listProductsSelected,
      dataDelivery,
      labelSelectProduct,
      dataHeaderTable,
      deliveryStore,
      isLoading,
      eventClickShowModal,
      checkSubmitActive,
      labelButtonSetting,
      errors,
      CommonService,
      onChange,
      validateForm,
      showModalProductList,
      eventSearchProduct,
      eventGetListProductsSelected,
      createDelivery,
      showModalProduct,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-partners-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
